import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderFlowmonResources extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
    this.minLabel = { en: 'min', de: 'minuten', nl: 'minuten', es: 'minutos', pt: 'minutos', fr: 'minutes', sv: 'minuter', jp: '分', 'zh-TW': '分', cs: 'min' };
  }

  getResourceCtaLabel(contentType) {
    const lang = this.filterService.getSelectedLanguage();

    const learnMoreLabel = { en: 'Learn more',cs: 'Learn more'};
    const downloadTheReportLabel = { en: 'Download the report',cs: 'Download the repor' };
    const downloadThePdfLabel = { en: 'Download the PDF', cs:'Download the PDF' };
    const viewTheInfographicLabel = { en: 'View the infographic', cs: 'View the infographic' };
    const watchTheVideoLabel = { en: 'Watch the video', cs: 'Watch the video' };
    const registerLabel = { en: 'Register', cs: 'Register' };
    const watchTheWebinarLabel = { en: 'Watch the webinar', cs: 'Watch the webinar' };
    const downloadLabel = { en: 'Download', cs: 'Download' };

    switch (contentType.Id) {
      case '95d3ec8e-65be-4005-bbbf-cf94764bec84': // Live webinar
        return registerLabel[lang];
      case 'ba3505a5-edf2-4b48-8196-3cd4ec03e8b3': // On-demand webinar
        return watchTheWebinarLabel[lang];
      case 'c5dbf402-5020-4c9f-a6e5-80fbc168e2e8': // Video
        return watchTheVideoLabel[lang];
      case 'fba60918-8c88-4d01-afc9-63a9c113f644': // Analyst report
        return downloadTheReportLabel[lang];
      case 'eeb3c6b5-1f50-4737-a2f3-717e59683ec2': // Data sheet
      case '42bf0060-28dd-4c4c-a1a5-c6b74232ec40': // solution brief
      case '373353ab-677c-400d-807c-5c8699b8217b': // products brief
      case 'cf2fbb3b-dfe7-4f77-98c0-996293ee9d9e': // integrations
      case '8640bcb2-4c3d-4776-8140-eaba70d3bbbe': // specification
        return downloadThePdfLabel[lang];
      case '3db61f70-a14e-4431-8aef-2d9fd62ba222': // Infographic
        return viewTheInfographicLabel[lang];
      case '70ae4793-8040-4c66-8bdf-0a7f4e81ede7': // Best practice
      case '6e38772a-82c5-454a-b6e6-740504dce161': // Case study
      case '558909ec-3dd7-428e-95fe-679f8ca002e3': // Other
        return learnMoreLabel[lang];
      case 'fd8805fa-9232-4470-892e-e2e2bb263842': // Whitepaper
      case '63a9b7cc-0814-4876-8a8f-d77bd1451ddd': // Ebook
        return downloadLabel[lang];
      case '392a9cff-6d1f-48d2-a7b4-d5d158df3595': // Guides
        return learnMoreLabel[lang];
      default:
        return this.CTAText;
    }
  }

  getItemHtml(item, relatedMedia) {
    let formattedDate = null;

    const { imageData, fileData } = super.setRelatedMedia(item, relatedMedia);
    const { Title, CTAText, UrlName: resourcePath, Summary, ExternalUrl, CTAUrl } = item;
    const contentType = item.resourceCategory[0];
    const pageUrl = super.getResourceUrl(item.contenttypes[0]);
    const featuredLabel = Boolean(Number(item.IsFeatured)) ? '<span class="Resource-featured-label -wa -fs11 -ttu -mt1 -mb1">Featured</span>' : '';
    const selectedLanguage = this.filterService.getSelectedLanguage();
    const imageFallback = 'https://d34smkdb128qfi.cloudfront.net/images/librariesprovider2/default-album/resources/resource-default-thumbnail.jpg';
    const summary = Summary ? `<div class="Resource-summary -fs16">${this.encodeHtml(Summary)}</div>` : '';
    let resourceUrl = `${pageUrl}/${resourcePath}`;

    // Live Webinar Start Date
    if (contentType.Id === '95d3ec8e-65be-4005-bbbf-cf94764bec84' && item.StartDate !== null) {
      let startDate = item.StartDate;
      let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      let webinarDate = new Date(startDate);
      formattedDate = webinarDate.toLocaleDateString(selectedLanguage, options);
    }

    // Video Play Icon
    if (contentType.Id === 'C5DBF402-5020-4C9F-A6E5-80FBC168E2E8') {
      resourceEmbed += ' -i-play-lite -i--overlay -fs70 -accent-white';
    }

    if (CTAUrl) {
      resourceUrl = CTAUrl;
    } else if (ExternalUrl) {
      resourceUrl = ExternalUrl;
    }

    const html = `
      <div class="col-4 -xl-half -l-half -m-half -s-full -mb3">
        <div class="Resource -full -tint-white -br5 -h-scale">
          <a href="${fileData == null ? resourceUrl : fileData.Url}" class="Embed Embed--16by9 -db -tint-black">
          <div class="-ml1 -pa -z1">${featuredLabel}</div>
              <div>
                ${imageData && imageData.Url ? `<img src="${imageData.Url}" alt="${imageData.AlternativeText}" class="-full">` : `<img src="${imageFallback}" alt="${imageData.AlternativeText}" class="-full">`}
              </div>
              ${!item.VideoLength ? '' : `<div class="Resource-floatingLabel -tint-white -ttn">${item.VideoLength}${this.minLabel[selectedLanguage] || this.minLabel.en}</div>`}
          </a>
          <div class="-df -mt0 -p2 -pb3 -full">
            <div class="-fs0 -mb1"><div class="Resource-label -ff-title -fs16 -ttu -c-grey3 -lh125">${contentType.Title}</div></div>
            <h5 class="${formattedDate != null ? '-mb0' : ''}">${this.encodeHtml(Title)}</h5>
            ${summary}
            <div class="-fs14 -fw3 -mb1">${formattedDate != null ? formattedDate : ''}</div>
            <a href="${fileData == null ? resourceUrl : fileData.Url}" class="-fs16 -fw5 -mta">
              <span class="-i-arrow -fs20"></span>
              ${this.encodeHtml(this.getResourceCtaLabel(contentType) || CTAText)}
            </a>
          </div>
        </div>
      </div>
    `;

    return html;
  }
}
